import { render, staticRenderFns } from "./Deselect.vue?vue&type=template&id=1f51e8a5&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


// WEBPACK FOOTER //
// webpack://VueSelect/src/components/Deselect.vue